import { useAtom } from 'jotai';
import { DayPicker } from 'react-day-picker';

// Atoms
import { datepickerAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';

// Types
import type { DayClickEventHandler } from 'react-day-picker';
import type { DatepickerSingleAtomImmer } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';
import type { DatepickerCalendarProps } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar';

// Components
import DatepickerBannerDataRetention from '@/components/composite/Datepicker/DatepickerBannerDataRetention';

type DatepickerSingleProps = DatepickerCalendarProps;

export function DatepickerSingle({ displayDataRetentionBanner }: DatepickerSingleProps) {
    const [datepicker, setDatepicker] = useAtom(datepickerAtom as DatepickerSingleAtomImmer);

    const fromDate = datepicker.settings?.minDate ? new Date(datepicker.settings.minDate) : null;
    const toDate = datepicker.settings?.maxDate ? new Date(datepicker.settings.maxDate) : null;

    const handleDayClick: DayClickEventHandler = (day) => {
        setDatepicker((draft) => {
            draft.date = day;
        });
    };

    return (
        <div className="px-2 py-5">
            <DayPicker
                mode="single"
                className="day-picker-single"
                showOutsideDays
                fromDate={fromDate}
                toDate={toDate}
                selected={datepicker.date}
                onDayClick={handleDayClick}
                {...datepicker.dayPickerOptions}
            />
            {displayDataRetentionBanner ? (
                <div className="mt-3 px-3">
                    <DatepickerBannerDataRetention />
                </div>
            ) : null}
        </div>
    );
}
